import store from '../../../store/index'

export function filteredOrders( state ) {
    return state.groupList
}

export function filteredOrdersItems( state ) {    
    return state.groupList;
}

export function detailOrderGetter( state ) {    
    return state.detailOrder;
}

